import React from "react";
import Box from "@mui/material/Box";
import CornerstoneViewport from "react-cornerstone-viewport";

type BasicViewerType = {
  width: string;
  height: string;
  imageIds: string[];
};

export function BasicViewer(props: BasicViewerType) {
  const width = props.width;
  const height = props.height;

  const [activeViewportIndex, setActiveViewportIndex] =
    React.useState<number>(0);
  const [activeTool, setActiveTool] = React.useState<string>("Wwwc");
  const [imageIdIndex, setImageIdIndex] = React.useState<number>(0);
  const [isPlaying, setIsPlaying] = React.useState<boolean>(false);
  const [frameRate, setFrameRate] = React.useState<number>(5);
  const [imageIds, setImageIds] = React.useState<string[]>(props.imageIds);

  const tools = [
    // Mouse
    {
      name: "Wwwc",
      mode: "active",
      modeOptions: { mouseButtonMask: 1 },
    },
    {
      name: "Zoom",
      mode: "active",
      modeOptions: { mouseButtonMask: 2 },
    },
    {
      name: "Pan",
      mode: "active",
      modeOptions: { mouseButtonMask: 4 },
    },
    // Scroll
    { name: "StackScrollMouseWheel", mode: "active" },
  ];
  return (
    <div>
      {Array.isArray(imageIds) && imageIds.length > 0 ? (
        <Box sx={{ width: width, height: height }}>
          <CornerstoneViewport
            tools={tools}
            imageIds={imageIds}
            imageIdIndex={imageIdIndex}
            isPlaying={isPlaying}
            frameRate={frameRate}
            activeTool={activeTool}
          />
        </Box>
      ) : (
        <div />
      )}
    </div>
  );
}
